webpackJsonp([14],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(85);
var core = __webpack_require__(12);
var ctx = __webpack_require__(101);
var hide = __webpack_require__(103);
var has = __webpack_require__(89);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(102);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(104);
var createDesc = __webpack_require__(109);
module.exports = __webpack_require__(87) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var IE8_DOM_DEFINE = __webpack_require__(106);
var toPrimitive = __webpack_require__(108);
var dP = Object.defineProperty;

exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(87) && !__webpack_require__(88)(function () {
  return Object.defineProperty(__webpack_require__(107)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
var document = __webpack_require__(85).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(86);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(111);
var gOPS = __webpack_require__(122);
var pIE = __webpack_require__(123);
var toObject = __webpack_require__(124);
var IObject = __webpack_require__(91);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(88)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(112);
var enumBugKeys = __webpack_require__(121);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(89);
var toIObject = __webpack_require__(90);
var arrayIndexOf = __webpack_require__(114)(false);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 113:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(90);
var toLength = __webpack_require__(115);
var toAbsoluteIndex = __webpack_require__(116);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(93);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(93);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(118)('keys');
var uid = __webpack_require__(120);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var global = __webpack_require__(85);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(119) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 120:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 122:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 123:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(92);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".vld-overlay{bottom:0;left:0;position:absolute;right:0;top:0;align-items:center;display:none;justify-content:center;overflow:hidden;z-index:1}.vld-overlay.is-active{display:flex}.vld-overlay.is-full-page{z-index:999;position:fixed}.vld-overlay .vld-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#fff;opacity:.5}.vld-overlay .vld-icon,.vld-parent{position:relative}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/node_modules/vue-loading-overlay/dist/vue-loading.css"],"names":[],"mappings":"AAAA,aACE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,gBAAiB,AACjB,SAAU,CACX,AAED,uBACE,YAAa,CACd,AAED,0BACE,YAAa,AACb,cAAe,CAChB,AAED,6BACE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,gBAAiB,AACjB,UAAY,CACb,AAMD,mCACE,iBAAkB,CACnB","file":"vue-loading.css","sourcesContent":[".vld-overlay {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  align-items: center;\n  display: none;\n  justify-content: center;\n  overflow: hidden;\n  z-index: 1\n}\n\n.vld-overlay.is-active {\n  display: flex\n}\n\n.vld-overlay.is-full-page {\n  z-index: 999;\n  position: fixed\n}\n\n.vld-overlay .vld-background {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: #fff;\n  opacity: 0.5\n}\n\n.vld-overlay .vld-icon {\n  position: relative\n}\n\n.vld-parent {\n  position: relative\n}\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wallet.62540ee.png";

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remoney.5693b02.png";

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_services__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      submitted: false,
      flag_cash: 0,
      fac_Refund: 0,
      payload: '',
      txn_id: '',
      info: {},
      isLoadingcash: '',
      walletChangeID: [{
        data: ''
      }, {
        data: ''
      }, {
        data: ''
      }, {
        data: '-'
      }, {
        data: ''
      }, {
        data: ''
      }, {
        data: ''
      }, {
        data: '-'
      }, {
        data: ''
      }, {
        data: ''
      }, {
        data: ''
      }, {
        data: ''
      }],
      numberID: '',
      ChangeID: '',
      checkonhand: '',
      status_partner: false,
      checkWebSocket: false
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['isLoading', 'UUID', 'lang', 'IDWallet', 'SaleID', 'SaleType', 'PaymentType', 'accessToken', 'AmountPayment', 'reponseStatus', 'sale_info', 'printer_step', 'sale_pay', 'config', 'sale_subs_slip']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['onMessageWs'])),
  methods: {
    back: function back() {
      var _this = this;

      this.Soundclick();
      if (this.AmountPayment > 0) {
        __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('show');
        this.$socket.sendObj({
          command: 'receive_close'
        });
      } else {
        clearTimeout(this.checkonhand);
        var obj = {
          ref_number: this.$store.state.ref_number,
          status: 'REJECTED'
        };
        var header = {
          headers: {
            'x-access-token': this.accessToken
            // "x-access-token": '942be569a799418c9b4249dc964e7930'
          }
        };
        __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].getReceiveC9(obj, header, function (result) {
          _this.$store.state.IDWallet = null;

          // this.$router.push({ื
          //   name: 'Main'
          // })
          _this.$router.go(-1);
          // this.$store.state.AmountPayment = 0
          // this.$store.state.sale_subs = []
          _this.$socket.sendObj({
            command: 'receive_close'
          });
          _this.$store.state.isLoading = true;
        }, function (error) {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
      }
    },
    websocket_onmessage: function websocket_onmessage() {
      var _this2 = this;

      this.$socket.onmessage = function (skResult) {
        _this2.$store.commit('onMessageWs', JSON.parse(skResult.data));
        _this2.check_cashrecive();
      };
    },
    check_cashrecive: function check_cashrecive() {
      if (this.$store.state.AmountPayment >= this.$store.state.total) {
        this.Payment();
        // if(this.SaleID != 1){
        //   if(this.AmountPayment >= this.$store.state.total && this.checkWebSocket == false) {
        //     this.checkWebSocket = true
        //     this.$socket.sendObj({
        //       command: 'receive_close'
        //     })
        //     $('#walletid').modal('show')
        //     console.log("จ่ายเงินครบแล้ว")
        //   }
        // }
      }
    },
    ReceiveMoney: function ReceiveMoney() {
      var _this3 = this;

      try {
        this.$socket.sendObj({
          command: 'receive_open'
        });

        this.$store.state.isLoading = true;
        this.checkonhand = setTimeout(function () {
          if (_this3.isLoading === true) {
            _this3.$socket.sendObj({
              command: 'receive_close'
            });
            _this3.$store.state.isLoading = false;
            alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่');
            _this3.$router.go(-1);
          }
        }, 10000);
      } catch (e) {
        alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่');
        this.$store.state.IDWallet = null;

        // console.log("asda",e)
        // location.reload()
        this.back();
      }
    },
    BackReceiveMoney: function BackReceiveMoney() {
      var _this4 = this;

      this.$socket.sendObj({
        command: 'receive_open'
      });

      this.$store.state.isLoading = true;
      this.checkonhand = setTimeout(function () {
        if (_this4.isLoading === true) {
          _this4.$store.state.isLoading = false;
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire({
            title: 'ระบบมีปัญหา?',
            text: 'กรุณาลองทำการการใหม่',
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            // cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง'
            // cancelButtonText: 'No'
          }).then(function (result) {
            if (result.value) {
              __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('show');
              _this4.$socket.sendObj({
                command: 'receive_open'
              });
            }
          });
        }
      }, 10000);
    },
    openSale: function openSale() {
      var _this5 = this;

      var header = {
        headers: {
          'x-access-token': this.accessToken
        }
      };

      __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].openSale(header, function (result) {
        _this5.txn_id = result.txn_id;
        _this5.$store.state.sale_info = result.info;
      }, function (error) {});
    },
    refund: function refund() {
      var _this6 = this;

      // this.SaleID = 1
      this.Soundclick();
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('hide');
      var header = {
        headers: {
          'x-access-token': this.accessToken
        }
      };

      if (this.SaleID == 1) {
        var mode = 'Deposit';
        var payment_type_text = 'cash';
        var type_text = 'Wallet';
        switch (this.lang) {
          case 0:
            payment_type_text = 'cash';
            type_text = 'Wallet';
            mode = 'Deposit';
            break;
          case 1:
            payment_type_text = 'เงินสด';
            type_text = 'เติมเงิน Wallet';
            mode = 'เติมเงิน';
            break;
          case 2:
            payment_type_text = '現金';
            type_text = 'Wallet';
            mode = '存款';
            break;
        }
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ''
        }];
      }

      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.txn_id;
        this.status_partner = false;
      } else {
        this.status_partner = true;
      }
      var numberPhone = this.$store.state.IDWallet.substring(1, this.$store.state.IDWallet.length);

      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.txn_id,
        type: 'deposit_cash',
        partner: this.status_partner,
        member_phone: '+66' + numberPhone,
        amount: parseFloat(this.AmountPayment),
        payment_received: parseFloat(this.AmountPayment),
        payment_change: 0,
        flag_cash: 0,
        payment: {
          currency: 'THB',
          b1000: this.sale_pay.b1000,
          b500: this.sale_pay.b500,
          b100: this.sale_pay.b100,
          b50: this.sale_pay.b50,
          b20: this.sale_pay.b20,
          c10: this.sale_pay.c10,
          c5: this.sale_pay.c5,
          c2: this.sale_pay.c2,
          c1: this.sale_pay.c1,
          c050: 0,
          c025: 0
        },
        pay_change: {
          b1000: 0,
          b500: 0,
          b100: 0,
          b50: 0,
          b20: 0,
          c10: 0,
          c5: 0,
          c2: 0,
          c1: 0,
          c050: 0,
          c025: 0
        },
        items: this.$store.state.sale_subs
      };

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].closeSaleV2(this.payload, header, function (result) {
        if (result.response == 'success') {
          // this.$socket.sendObj({
          //   command: 'receive_close'
          // })
          if (_this6.$store.state.SaleID == 5) {
            var obj = {
              ref_number: _this6.$store.state.ref_number,
              status: 'PROCESSING'
            };
            __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].getReceiveC9(obj, header, function (result) {
              var text = '';
              var title = '';
              switch (_this6.lang) {
                case 0:
                  text = 'Already refunded to your wallet.';
                  title = 'Process';
                  break;
                case 2:
                  text = '已退還到您的錢包';
                  title = '處理';
                  break;
                default:
                  text = 'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว';
                  title = 'ประมวลผล';
                  break;
              }
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(title, text, 'success');
              _this6.$router.push({
                name: 'Main'
              });
            }, function (error) {
              alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
            });
          } else {
            if (_this6.$store.state.acl === 1) {
              _this6.$socket.sendObj({
                command: 'open_cash_box',
                data: 10
              });
            }
            var text = '';
            var title = '';
            switch (_this6.lang) {
              case 0:
                text = 'Already refunded to your wallet.';
                title = 'Process';
                break;
              case 2:
                text = '已退還到您的錢包';
                title = '處理';
                break;
              default:
                text = 'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว';
                title = 'ประมวลผล';
                break;
            }
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(title, text, 'success');
            _this6.$router.push({
              name: 'Main'
            });
          }
        } else {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
        }
        _this6.$store.state.isLoading = false;
      }, function (error) {
        _this6.$store.state.isLoading = false;
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    checkValid: function checkValid() {
      var _this7 = this;

      this.Soundclick();
      var header = {
        headers: {
          'x-access-token': this.accessToken
        }
      };
      if (!this.IDWallet) {
        this.$store.state.IDWallet = '';
        this.walletChangeID.forEach(function (val) {
          if (val['data'] != '-') {
            _this7.$store.state.IDWallet += val['data'];
          }
        });
      }
      var numberPhone = this.IDWallet.substring(1, this.IDWallet.length);
      var body = {
        // _compgrp: "commons",
        // _comp: "api",
        // _action: "validate",
        // vending_id: this.$store.state.UUID,
        code: '+66' + numberPhone
      };
      __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].checkValidate(body, header, function (result) {
        if (result.response == 'invalid') {
          var text = '';
          var title = '';
          var text2 = '';
          var title2 = '';
          switch (_this7.lang) {
            case 0:
              text = 'This number has not been confirmed by the owner. Do you want to register?';
              title = 'Notification';
              text2 = 'Successful member registration Please contact the staff to confirm ownership';
              title2 = 'Notification';
              break;
            case 2:
              text = '該號碼尚未得到業主的確認。你想註冊嗎？';
              title = '來自系統的通知';
              text2 = '會員註冊成功請聯繫工作人員確認所有權。';
              title2 = '來自系統的通知';
              break;
            default:
              text = 'หมายเลขนี้ยังไม่ได้ยืนยันเจ้าของ ท่านต้องการลงทะเบียนหรือไม่ ?';
              title = 'แจ้งเตือนจากระบบ';
              text2 = 'การลงทะเบียนรหัสสมาชิกสำเร็จ กรุณาติดต่อเจ้าหน้าที่เพื่อยืนยันความเป็นเจ้าของ';
              title2 = 'แจ้งเตือนจากระบบ';
              break;
          }
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire({
            title: title,
            text: text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(function (result) {
            if (result.value) {
              _this7.refund();
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire(title2, text2, 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('show');
            }
          });
        } else {
          _this7.$store.state.sale_subs = [];
          _this7.SaleID = 1;
          _this7.refund();
        }
      }, function (error) {
        _this7.$store.state.isLoading = false;
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    Payment: function Payment() {
      var _this8 = this;

      this.$store.state.isLoading = true;
      this.Soundclick();
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('hide');
      var header = {
        headers: {
          'x-access-token': this.accessToken
        }
      };
      if (this.SaleID == 1) {
        var mode = 'Deposit';
        var payment_type_text = 'cash';
        var type_text = 'Wallet';
        switch (this.lang) {
          case 0:
            payment_type_text = 'cash';
            type_text = 'Wallet';
            mode = 'Deposit';
            break;
          case 1:
            payment_type_text = 'เงินสด';
            type_text = 'เติมเงิน Wallet';
            mode = 'เติมเงิน';
            break;
          case 2:
            payment_type_text = '現金';
            type_text = 'Wallet';
            mode = '存款';
            break;
        }
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ''
        }];
      }

      if (!this.IDWallet) {
        this.$store.state.IDWallet = '';
        this.walletChangeID.forEach(function (val) {
          if (val['data'] != '-') {
            _this8.$store.state.IDWallet += val['data'];
          }
        });
      }
      var saletype = '';
      switch (this.SaleID) {
        case 1:
          saletype = 'deposit_cash';
          break;
        case 2:
          saletype = 'sale_cash';
          break;
        case 3:
          saletype = '';
          break;
        case 4:
          saletype = 'sale_cash';
          break;
        case 5:
          saletype = 'sale_cash';
          break;
        default:
          saletype = 'deposit';
          break;
      }
      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.txn_id;
        this.status_partner = false;
      } else {
        this.status_partner = true;
      }
      if (this.IDWallet.length > 0) {
        var numberPhone = this.IDWallet.substring(1, this.IDWallet.length);
        var phone = '+66' + numberPhone;
      } else {
        var phone = '';
      }
      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.txn_id,
        type: saletype,
        partner: this.status_partner,
        member_phone: phone,
        amount: parseFloat(this.$store.state.total),
        payment_received: parseFloat(this.AmountPayment),
        payment_change: parseFloat(this.$store.state.total) - parseFloat(this.AmountPayment),
        flag_cash: this.flag_cash,
        payment: {
          currency: 'THB',
          b1000: this.sale_pay.b1000,
          b500: this.sale_pay.b500,
          b100: this.sale_pay.b100,
          b50: this.sale_pay.b50,
          b20: this.sale_pay.b20,
          c10: this.sale_pay.c10,
          c5: this.sale_pay.c5,
          c2: this.sale_pay.c2,
          c1: this.sale_pay.c1,
          c050: 0,
          c025: 0
        },
        pay_change: {
          b1000: 0,
          b500: 0,
          b100: 0,
          b50: 0,
          b20: 0,
          c10: 0,
          c5: 0,
          c2: 0,
          c1: 0,
          c050: 0,
          c025: 0
        },
        items: this.$store.state.sale_subs
      };

      if (this.AmountPayment >= this.$store.state.total) {
        this.$store.state.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].closeSaleV2(this.payload, header, function (result) {
          if (result.response == 'success') {
            _this8.$socket.sendObj({
              command: 'receive_close'
            });
            if (_this8.SaleID == 1) {} else if (_this8.$store.state.IDWallet == _this8.$store.state.config.client.telephone) {
              // if (this.$store.state.IDWallet == "0613351889") {
              var data_slip = {
                "command": "print_slip",
                "data": {
                  "client_tax_id": "",
                  "shop_title": _this8.$store.state.config.client.shop_title,
                  "shop_website": _this8.$store.state.config.client.shop_website,
                  "logo_image_width": 300,
                  "total": parseFloat(_this8.$store.state.total),
                  "payment": parseFloat(_this8.AmountPayment),
                  "change": (parseFloat(_this8.$store.state.total) - parseFloat(_this8.AmountPayment)) * -1,
                  "type": "take_home",
                  "unchange": (parseFloat(_this8.$store.state.total) - parseFloat(_this8.AmountPayment)) * -1,
                  "status": 0,
                  "queue_no": result.queue,
                  "sale_pay": {
                    "B1000": _this8.sale_pay.b1000,
                    "B500": _this8.sale_pay.b500,
                    "B100": _this8.sale_pay.b100,
                    "B50": _this8.sale_pay.b50,
                    "B20": _this8.sale_pay.b20,
                    "C10": _this8.sale_pay.c10,
                    "C5": _this8.sale_pay.c5,
                    "C2": _this8.sale_pay.c2,
                    "C1": _this8.sale_pay.c1
                  },
                  "sale_subs": _this8.$store.state.sale_subs_slip
                }
                // var data_slip = {
                //   "command": "print_unpaid_change",
                //   "data": {
                //     "queue_number": result.queue,
                //     "shop_title": this.$store.state.config.client.shop_title,
                //     "vending_id": 102,
                //     "unpaid_change": (parseFloat(this.$store.state.total)-parseFloat(this.AmountPayment))*(-1),
                //     "mode": 0
                //   }
                // }
              };
              _this8.$socket.sendObj(data_slip);
            } else {
              var data_slip = {
                "command": "print_slip",
                "data": {
                  "client_tax_id": "",
                  "shop_title": _this8.$store.state.config.client.shop_title,
                  "shop_website": _this8.$store.state.config.client.shop_website,
                  "logo_image_width": 300,
                  "total": parseFloat(_this8.$store.state.total),
                  "payment": parseFloat(_this8.AmountPayment),
                  "change": (parseFloat(_this8.$store.state.total) - parseFloat(_this8.AmountPayment)) * -1,
                  "type": "take_home",
                  "unchange": 0,
                  "status": 0,
                  "queue_no": result.queue,
                  "sale_pay": {
                    "B1000": _this8.sale_pay.b1000,
                    "B500": _this8.sale_pay.b500,
                    "B100": _this8.sale_pay.b100,
                    "B50": _this8.sale_pay.b50,
                    "B20": _this8.sale_pay.b20,
                    "C10": _this8.sale_pay.c10,
                    "C5": _this8.sale_pay.c5,
                    "C2": _this8.sale_pay.c2,
                    "C1": _this8.sale_pay.c1
                  },
                  "sale_subs": _this8.$store.state.sale_subs_slip
                }
              };

              _this8.$socket.sendObj(data_slip);
            }
            if (_this8.$store.state.SaleID == 5) {
              var obj = {
                ref_number: _this8.$store.state.ref_number,
                status: 'PROCESSING'
              };
              __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].getReceiveC9(obj, header, function (result) {
                _this8.$store.state.history_page = 'Cash';
                _this8.$router.push({
                  name: 'ProcessCash'
                });
              }, function (error) {
                alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
              });
            } else {
              if (_this8.$store.state.acl === 1) {
                _this8.$socket.sendObj({
                  command: 'open_cash_box',
                  data: 10
                });
              }
              _this8.$store.state.history_page = 'Cash';
              _this8.$router.push({
                name: 'ProcessCash'
              });
            }
          } else {
            alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
          }
          _this8.$store.state.isLoading = false;
        }, function (error) {
          _this8.$store.state.isLoading = false;
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
      }
    },
    delayloading: function delayloading() {
      this.isLoadingcash = true;
      setInterval(function () {
        this.isLoadingcash = false;
      }.bind(this), 2000);
    },
    openModal: function openModal() {
      var _this9 = this;

      this.$store.state.isLoading = true;
      if (this.AmountPayment == 0) {

        return;
      } else if (this.AmountPayment >= this.$store.state.total) {
        if (this.IDWallet) {
          this.ChangeID = this.IDWallet;
          this.Payment();
        } else {
          if (this.SaleID === 5) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire({
              title: 'แจ้งเตือนจากระบบ?',
              text: 'ท่านต้องการรับใบเสร็จออนไลน์หรือไม่ ?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
            }).then(function (result) {
              if (result.value) {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('show');
                _this9.$socket.sendObj({
                  command: 'receive_close'
                });
              } else {
                _this9.Payment();
              }
            });
          } else {
            if (this.AmountPayment > this.$store.state.total) {
              __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('show');
              this.$socket.sendObj({
                command: 'receive_close'
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire({
                title: 'แจ้งเตือนจากระบบ?',
                text: 'ท่านต้องการรับใบเสร็จออนไลน์หรือไม่ ?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              }).then(function (result) {
                if (result.value) {
                  __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#walletid').modal('show');
                  _this9.$socket.sendObj({
                    command: 'receive_close'
                  });
                } else {
                  _this9.Payment();
                }
              });
            }
          }
        }
        this.$store.state.isLoading = false;
      } else {
        if (this.SaleID == 1) {
          if (this.AmountPayment > 0) {
            this.Payment();
          }
        }
        this.$store.state.isLoading = false;
      }
    },
    checkMobile: function checkMobile() {
      if (this.numberID.length > 11) {
        if (this.walletChangeID[0]['data'] === '0') {
          this.Payment();
        } else {
          var text = '';
          var title = '';
          switch (this.lang) {
            case 0:
              text = 'Please enter the ID Wallet you want to fill.';
              title = 'Warning';
              break;
            case 2:
              text = '請輸入您要填寫的代碼。';
              title = '通知';
              break;
            default:
              text = 'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ลงในช่องว่าง ให้ถูกต้อง';
              title = 'แจ้งเตือน';
              break;
          }
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(title, text, 'warning');
        }
      } else {
        var _text = '';
        var _title = '';
        switch (this.lang) {
          case 0:
            _text = 'Please enter the ID Wallet you want to fill.';
            _title = 'Warning';
            break;
          case 2:
            _text = '請輸入您要填寫的代碼。';
            _title = '通知';
            break;
          default:
            _text = 'กรุณากรอกเบอร์โทรศัพท์ ลงในช่องว่างให้ถูกต้อง';
            _title = 'แจ้งเตือน';
            break;
        }
        __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(_title, _text, 'warning');
      }
    },
    addAmount: function addAmount(int) {
      this.Soundclick();
      if (this.numberID.length < 12) {
        this.numberID += int.toString();
        this.walletChangeID[this.numberID.length - 1]['data'] = int;
        if (this.numberID.length == 3 || this.numberID.length == 7) {
          this.numberID += '-';
          this.walletChangeID[this.numberID.length - 1]['data'] = '-';
        }
      }
    },
    del: function del() {
      if (this.numberID.length > 0) {
        if (this.numberID.length == 4 || this.numberID.length == 8) {
          this.numberID = this.numberID.substring(0, this.numberID.length - 2);
          this.walletChangeID[this.numberID.length]['data'] = '';
        } else {
          this.numberID = this.numberID.substring(0, this.numberID.length - 1);
          this.walletChangeID[this.numberID.length]['data'] = '';
        }
      }
    },
    addmonnyTest: function addmonnyTest(val) {
      AmountPayment += parseInt(val);
    },
    submitter: function submitter() {
      this.Soundclick();
      if (this.AmountPayment == 0) {
        return;
      } else if (this.AmountPayment >= this.$store.state.total) {
        __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#condition').modal('show');
      } else {
        this.openModal();
      }
    },
    switchPayment: function switchPayment(val) {
      if (val == 1) {
        __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#condition').modal('hide');
        this.flag_cash = 1;
        // this.$store.state.IDWallet = '0613351889'
        this.$store.state.IDWallet = this.$store.state.config.client.telephone;
        this.Payment();
      }
      if (val == 2) {
        __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#condition').modal('hide');
        this.openModal();
      }
    }
  },
  mounted: function mounted() {
    this.delayloading();
    this.websocket_onmessage();
    this.$store.state.AmountPayment = 0;
    this.ReceiveMoney();
    this.openSale();

    clearInterval(this.$store.state.setInter);
    if (this.SaleID < 1 || !this.SaleID) {
      this.$router.push({
        name: 'Main'
      });
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(249);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("2de3c818", content, true, {});

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, "body[data-v-2f508e40]{padding-top:0!important}.input-money[data-v-2f508e40]{border:10px solid red;border-radius:10px;padding-top:15px}.description[data-v-2f508e40],.input-money[data-v-2f508e40]{width:100%;background:#fff;height:130px;overflow:hidden;margin:0}.description[data-v-2f508e40]{border:5px solid gray!important;border-radius:10px;padding-top:5px}.ID[data-v-2f508e40]{width:95px;padding-top:5px;padding-bottom:0;margin-left:2.5px;border:2px solid #000;border-radius:4px}.ID-BB[data-v-2f508e40]{border:0}.BG[data-v-2f508e40]{background:#dfc}.BGR[data-v-2f508e40]{background:#f27b7b}.btn-w-pad[data-v-2f508e40]{width:100%;height:90px;background:#1f1f14!important;font-size:80px;line-height:90px;color:#fff}.btn-w-pad[data-v-2f508e40]:active{background:#c2c2a3!important;border:0;color:#000}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/Cash.vue"],"names":[],"mappings":"AACA,sBACE,uBAA4B,CAC7B,AACD,8BAGE,sBAAuB,AAEvB,mBAAoB,AACpB,gBAAkB,CAGnB,AACD,4DATE,WAAY,AACZ,gBAAiB,AAEjB,aAAc,AAGd,gBAAiB,AACjB,QAAY,CAWb,AATD,8BAGE,gCAAkC,AAElC,mBAAoB,AACpB,eAAiB,CAGlB,AACD,qBACE,WAAY,AACZ,gBAAiB,AACjB,iBAAoB,AACpB,kBAAmB,AACnB,sBAAuB,AACvB,iBAAmB,CACpB,AACD,wBACE,QAAY,CACb,AACD,qBACE,eAAoB,CACrB,AACD,sBACE,kBAAoB,CACrB,AACD,4BACE,WAAY,AACZ,YAAa,AACb,6BAA+B,AAC/B,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACb,AACD,mCACE,6BAA+B,AAC/B,SAAY,AACZ,UAAY,CACb","file":"Cash.vue","sourcesContent":["\nbody[data-v-2f508e40] {\r\n  padding-top: 0px !important;\n}\n.input-money[data-v-2f508e40] {\r\n  width: 100%;\r\n  background: #fff;\r\n  border: 10px solid red;\r\n  height: 130px;\r\n  border-radius: 10px;\r\n  padding-top: 15px;\r\n  overflow: hidden;\r\n  margin: 0px;\n}\n.description[data-v-2f508e40] {\r\n  width: 100%;\r\n  background: #fff;\r\n  border: 5px solid gray !important;\r\n  height: 130px;\r\n  border-radius: 10px;\r\n  padding-top: 5px;\r\n  overflow: hidden;\r\n  margin: 0px;\n}\n.ID[data-v-2f508e40] {\r\n  width: 95px;\r\n  padding-top: 5px;\r\n  padding-bottom: 0px;\r\n  margin-left: 2.5px;\r\n  border: 2px solid #000;\r\n  border-radius: 4px;\n}\n.ID-BB[data-v-2f508e40] {\r\n  border: 0px;\n}\n.BG[data-v-2f508e40] {\r\n  background: #ddffcc;\n}\n.BGR[data-v-2f508e40] {\r\n  background: #f27b7b;\n}\n.btn-w-pad[data-v-2f508e40] {\r\n  width: 100%;\r\n  height: 90px;\r\n  background: #1f1f14 !important;\r\n  font-size: 80px;\r\n  line-height: 90px;\r\n  color: #fff;\n}\n.btn-w-pad[data-v-2f508e40]:active {\r\n  background: #c2c2a3 !important;\r\n  border: 0px;\r\n  color: #000;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"min-height":"600px","padding-top":"40px"},style:({ 'background-image': 'url()' })},[(_vm.lang == 0)?_c('h1',{staticStyle:{"font-size":"100px","color":"#555","padding":"0","line-height":"50px"}},[_vm._v("Cash")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h1',{staticStyle:{"font-size":"100px","color":"#555","padding":"0","line-height":"50px"}},[_vm._v("เงินสด")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h1',{staticStyle:{"font-size":"100px","color":"#555","padding":"0","line-height":"50px"}},[_vm._v("现金")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between",staticStyle:{"height":"450px","width":"100%"}},[_c('div',{staticClass:"d-flex align-items-start justify-content-start flex-wrap",staticStyle:{"width":"70%","height":"100%"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"margin-bottom":"-40px","margin-top":"20px"}},[(_vm.lang == 0 && _vm.$store.state.SaleID != 1)?_c('h2',{staticStyle:{"font-size":"70px","padding":"0","line-height":"100px","text-align":"left"},style:({ color: '#555' })},[_vm._v("\n               Sale balance\n          "),_c('span',{staticClass:"text-white",class:{ 'text-success': _vm.$store.state.total <= _vm.AmountPayment }},[_vm._v(_vm._s(_vm.money_format(_vm.$store.state.total)))]),_vm._v(" ฿\n        ")]):_vm._e(),_vm._v(" "),(_vm.lang == 1 && _vm.$store.state.SaleID != 1)?_c('h2',{staticStyle:{"font-size":"70px","padding":"0","line-height":"100px","text-align":"left"},style:({ color: '#555' })},[_vm._v("\n          ค้างชำระ\n          "),((_vm.$store.state.total - _vm.AmountPayment) > 0)?_c('span',{staticClass:"text-white",class:{ 'text-success': _vm.$store.state.total <= _vm.AmountPayment }},[_vm._v(_vm._s(_vm.money_format(_vm.$store.state.total - _vm.AmountPayment)))]):_vm._e(),_vm._v(" "),((_vm.$store.state.total - _vm.AmountPayment) <= 0)?_c('span',{staticClass:"text-white",class:{ 'text-success': _vm.$store.state.total <= _vm.AmountPayment }},[_vm._v(_vm._s(_vm.money_format(0)))]):_vm._e(),_vm._v("\n          บาท / เงินทอน\n          "),((_vm.$store.state.total - _vm.AmountPayment) > 0)?_c('span',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.money_format(0)))]):_vm._e(),_vm._v(" "),((_vm.$store.state.total - _vm.AmountPayment) <= 0)?_c('span',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.money_format(_vm.$store.state.total - _vm.AmountPayment)*(-1)))]):_vm._e(),_vm._v(" บาท\n        ")]):_vm._e(),_vm._v(" "),(_vm.lang == 2 && _vm.$store.state.SaleID != 1)?_c('h2',{staticStyle:{"font-size":"70px","padding":"0","line-height":"100px","text-align":"left"},style:({ color: '#555' })},[_vm._v("\n               出色的平衡\n          "),_c('span',{staticClass:"text-white",class:{ 'text-success': _vm.$store.state.total <= _vm.AmountPayment }},[_vm._v(_vm._s(_vm.money_format(_vm.$store.state.total)))]),_vm._v(" ฿\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-center input-money"},[_c('div',{staticStyle:{"font-size":"140px","font-weight":"bold","width":"20%","height":"130px","line-height":"130px"}},[_vm._v("฿")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"150px","font-weight":"bold","width":"80%","height":"130px","line-height":"120px","text-align":"right"}},[_vm._v(_vm._s(_vm.AmountPayment))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-start description flex-wrap mt-0"},[_c('div',{staticStyle:{"width":"45%"}},[_c('div',{staticStyle:{"width":"100%","text-align":"left","padding-left":"10px"}},[(_vm.lang == 0)?_c('h5',[_vm._v("Money available")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h5',[_vm._v("เงินที่ชำระได้")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h5',[_vm._v("钱可用")]):_vm._e()]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"walletid","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalScrollableTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-scrollable",staticStyle:{"max-width":"1024px"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"width":"900px","left":"60px"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"d-flex justify-content-around"},_vm._l((_vm.walletChangeID),function(w,i){return _c('span',{key:i,staticClass:"ID",class:{ 'ID-BB': i == 3 || i == 7, 'BG': w.data != '' && w.data != '-', 'BGR': _vm.walletChangeID[0]['data'] != '0' &&  _vm.walletChangeID[0]['data'] != '' && _vm.walletChangeID[0]['data'] != '-'}},[_c('b',{staticStyle:{"font-size":"80px","line-height":"50px"}},[_vm._v(_vm._s(w.data))])])}),0),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col-6",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('1')}}},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('2')}}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",on:{"click":function($event){_vm.addAmount('3')}}},[_vm._v("3")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('4')}}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('5')}}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('6')}}},[_vm._v("6")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('7')}}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('8')}}},[_vm._v("8")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('9')}}},[_vm._v("9")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('0')}}},[_vm._v("0")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-top":"2px solid #fff"},on:{"click":_vm.del}},[_vm._v("DEL")])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"border":"5px solid red","background":"#000"}},[_c('div',{staticClass:"text-left text-white",staticStyle:{"font-size":"24px"}},[(_vm.lang == 0)?_c('b',[_vm._v("Suggestion")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('b',[_vm._v("คำแนะนำ")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('b',[_vm._v("領導")]):_vm._e()]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0","border":"1px solid white","margin-bottom":"10px"}}),_vm._v(" "),_c('p',{staticClass:"text-left text-white",staticStyle:{"font-size":"20px"}},[(_vm.lang == 0)?_c('span',[_vm._v("1. Please enter your phone number to receive the change to Walt.")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('span',[_vm._v("1. กรุณากรอกรหัสเบอร์โทรเพื่อรับเงินทอนเข้าวอเล็ต")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('span',[_vm._v("1. 请输入您的电话号码以接收Walt的更改。")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.lang == 0)?_c('span',[_vm._v("2. Press the \"Change to wallet\" button. Receive change to the wallet.")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('span',[_vm._v("2. กดปุ่ม \"ทอนเข้าวอเล็ต\" รับเงินทอนเข้าวอเล็ต")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('span',[_vm._v("2. 按“更改为钱包”按钮。接收钱包的更改。")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.lang == 0)?_c('span',[_vm._v("3. Click the \"Change cash\" button. Receive change in cash.")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('span',[_vm._v("3. กดปุ่ม \"ทอนเงินสด\" รับเงินทอนเป็นเงินสด")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('span',[_vm._v("3. 点击“更改现金”按钮。接收现金变化。")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"2% 5% 0% 5%"}},[(_vm.fac_Refund == 0)?_c('div',{staticClass:"menu badge-danger",staticStyle:{"width":"45%","height":"150px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.switchPayment(1)}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(136),"alt":"cancel","width":"90"}}),_vm._v(" "),(_vm.lang == 0)?_c('h3',[_vm._v("Cash")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h3',[_vm._v("ทอนเงินสด")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h3',[_vm._v("同意")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.fac_Refund == 0)?_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"45%","height":"150px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.checkMobile()}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(130),"alt":"payment","width":"90"}}),_vm._v(" "),(_vm.lang == 0)?_c('h3',[_vm._v("Wallet")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h3',[_vm._v("ทอนเข้าวอเล็ท")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h3',[_vm._v("钱包")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.fac_Refund == 1)?_c('button',{staticClass:"btn btn-primary btn-block btn-lg mt-2",attrs:{"type":"button"},on:{"click":_vm.checkValid}},[(_vm.lang == 0)?_c('h1',[_vm._v("OK")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h1',[_vm._v("รับเงินคืน")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h1',[_vm._v("同意")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.fac_Refund == 1)?_c('button',{staticClass:"btn btn-danger btn-block btn-lg",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.BackReceiveMoney}},[(_vm.lang == 0)?_c('h1',[_vm._v("Close")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h1',[_vm._v("ปิด")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h1',[_vm._v("關閉")]):_vm._e()]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"condition","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalScrollableTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"1024px"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"width":"800px","left":"60px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col-12 row",staticStyle:{"padding-top":"10px","padding-left":"60px"}},[_c('div',{staticClass:"menu badge-danger",staticStyle:{"width":"45%","height":"150px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.switchPayment(1)}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(136),"alt":"cancel","width":"90"}}),_vm._v(" "),(_vm.lang == 0)?_c('h3',[_vm._v("Cash")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h3',[_vm._v("ทอนเงินสด")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h3',[_vm._v("同意")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"45%","height":"150px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.switchPayment(2)}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(130),"alt":"payment","width":"90"}}),_vm._v(" "),(_vm.lang == 0)?_c('h3',[_vm._v("Wallet")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('h3',[_vm._v("ทอนเข้าวอเล็ท")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('h3',[_vm._v("钱包")]):_vm._e()])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-around align-items-center",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center coin"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center coin",staticStyle:{"width":"60px","height":"60px"}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center coin",staticStyle:{"width":"70px","height":"70px"}},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center coin",staticStyle:{"width":"80px","height":"80px"}},[_vm._v("10")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-start flex-wrap",staticStyle:{"width":"55%"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center banknote",staticStyle:{"background":"#70db70"}},[_vm._v("20")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center banknote",staticStyle:{"background":"#80dfff","width":"110px"}},[_vm._v("50")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center banknote",staticStyle:{"background":"#ff8080","width":"115px"}},[_vm._v("100")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center banknote",staticStyle:{"background":"#ff66ff","width":"120px"}},[_vm._v("500")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-center banknote",staticStyle:{"background":"#ffeecc","width":"125px"}},[_vm._v("1000")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h1',{staticStyle:{"color":"#000","padding-bottom":"0px","margin-bottom":"0px"}},[_vm._v("กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์มือถือ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h1',{staticStyle:{"color":"#000","padding-bottom":"0px","margin-bottom":"0px"}},[_vm._v("กรุณาเลือกประเภทการทอนเงิน")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_cash_js__ = __webpack_require__(169);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f508e40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cash_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f508e40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_cash_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f508e40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(88)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(91);
var defined = __webpack_require__(92);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(113);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(97);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("VueLoading",[],e):"object"==typeof exports?exports.VueLoading=e():t.VueLoading=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=1)}([function(t,e,i){},function(t,e,i){"use strict";i.r(e);var n="undefined"!=typeof window?window.HTMLElement:Object,r={mounted:function(){document.addEventListener("focusin",this.focusIn)},methods:{focusIn:function(t){if(this.isActive&&t.target!==this.$el&&!this.$el.contains(t.target)){var e=this.container?this.container:this.isFullPage?null:this.$el.parentElement;(this.isFullPage||e&&e.contains(t.target))&&(t.preventDefault(),this.$el.focus())}}},beforeDestroy:function(){document.removeEventListener("focusin",this.focusIn)}};function a(t,e,i,n,r,a,o,s){var u,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=i,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),o?(u=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),u)if(l.functional){l._injectStyles=u;var c=l.render;l.render=function(t,e){return u.call(e),c(t,e)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,u):[u]}return{exports:t,options:l}}var o=a({name:"spinner",props:{color:{type:String,default:"#000"},height:{type:Number,default:64},width:{type:Number,default:64}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{viewBox:"0 0 38 38",xmlns:"http://www.w3.org/2000/svg",width:this.width,height:this.height,stroke:this.color}},[e("g",{attrs:{fill:"none","fill-rule":"evenodd"}},[e("g",{attrs:{transform:"translate(1 1)","stroke-width":"2"}},[e("circle",{attrs:{"stroke-opacity":".25",cx:"18",cy:"18",r:"18"}}),this._v(" "),e("path",{attrs:{d:"M36 18c0-9.94-8.06-18-18-18"}},[e("animateTransform",{attrs:{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.8s",repeatCount:"indefinite"}})],1)])])])},[],!1,null,null,null);o.options.__file="spinner.vue";var s=o.exports,u=a({name:"dots",props:{color:{type:String,default:"#000"},height:{type:Number,default:240},width:{type:Number,default:60}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{viewBox:"0 0 120 30",xmlns:"http://www.w3.org/2000/svg",fill:t.color,width:t.width,height:t.height}},[i("circle",{attrs:{cx:"15",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"60",cy:"15",r:"9","fill-opacity":"0.3"}},[i("animate",{attrs:{attributeName:"r",from:"9",to:"9",begin:"0s",dur:"0.8s",values:"9;15;9",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"0.5",to:"0.5",begin:"0s",dur:"0.8s",values:".5;1;.5",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"105",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})])])},[],!1,null,null,null);u.options.__file="dots.vue";var l=u.exports,c=a({name:"bars",props:{color:{type:String,default:"#000"},height:{type:Number,default:40},width:{type:Number,default:40}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 30 30",height:t.height,width:t.width,fill:t.color}},[i("rect",{attrs:{x:"0",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"10",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"20",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}})])])},[],!1,null,null,null);c.options.__file="bars.vue";var d=c.exports,f=a({name:"vue-loading",mixins:[r],props:{active:Boolean,programmatic:Boolean,container:[Object,Function,n],isFullPage:{type:Boolean,default:!0},transition:{type:String,default:"fade"},canCancel:Boolean,onCancel:{type:Function,default:function(){}},color:String,backgroundColor:String,opacity:Number,width:Number,height:Number,loader:{type:String,default:"spinner"}},data:function(){return{isActive:this.active}},components:{Spinner:s,Dots:l,Bars:d},beforeMount:function(){this.programmatic&&(this.container?(this.isFullPage=!1,this.container.appendChild(this.$el)):document.body.appendChild(this.$el))},mounted:function(){this.programmatic&&(this.isActive=!0),document.addEventListener("keyup",this.keyPress)},methods:{cancel:function(){this.canCancel&&this.isActive&&(this.hide(),this.onCancel.apply(null,arguments))},hide:function(){var t=this;this.$emit("hide"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){var e;t.$destroy(),void 0!==(e=t.$el).remove?e.remove():e.parentNode.removeChild(e)},150))},keyPress:function(t){27===t.keyCode&&this.cancel()}},watch:{active:function(t){this.isActive=t}},beforeDestroy:function(){document.removeEventListener("keyup",this.keyPress)}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:t.transition}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isActive,expression:"isActive"}],staticClass:"vld-overlay is-active",class:{"is-full-page":t.isFullPage},attrs:{tabindex:"0","aria-busy":t.isActive,"aria-label":"Loading"}},[i("div",{staticClass:"vld-background",style:{background:this.backgroundColor,opacity:this.opacity},on:{click:function(e){return e.preventDefault(),t.cancel(e)}}}),t._v(" "),i("div",{staticClass:"vld-icon"},[t._t("before"),t._v(" "),t._t("default",[i(t.loader,{tag:"component",attrs:{color:t.color,width:t.width,height:t.height}})]),t._v(" "),t._t("after")],2)])])},[],!1,null,null,null);f.options.__file="Component.vue";var p=f.exports,h=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return{show:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i,a=Object.assign({},e,n,{programmatic:!0}),o=new(t.extend(p))({el:document.createElement("div"),propsData:a}),s=Object.assign({},i,r);return Object.keys(s).map(function(t){o.$slots[t]=s[t]}),o}}};i(0);p.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=h(t,e,i);t.$loading=n,t.prototype.$loading=n};e.default=p}]).default});

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("4a1fd46d", content, true, {});

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(100);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(110) });


/***/ })

});


// WEBPACK FOOTER //
// static/js/14.f5125c8db80810daada6.js